var _mask, _g, _path, _path2, _mask2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMemo = function SvgMemo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "memo_svg__a",
    width: 23,
    height: 29,
    x: 2,
    y: 4,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2 4h22.588v28.235H2z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#memo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    fillRule: "evenodd",
    d: "M24.588 32.235H4.824A2.823 2.823 0 0 1 2 29.412V4h22.588z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF773D",
    fillRule: "evenodd",
    d: "M32.632 14.126a3.087 3.087 0 1 0-4.367-4.366L15.64 22.384l4.367 4.367z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B4B4B",
    fillRule: "evenodd",
    d: "M15.634 22.384 20 26.75l-5.299.933z",
    clipRule: "evenodd"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "memo_svg__b",
    width: 32,
    height: 29,
    x: 2,
    y: 4,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2 32.235h31.536V4H2z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#memo_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.706 10.588h13.176V8.706H6.706zM6.706 16.235h7.53v-1.882h-7.53z"
  }))));
};
export default SvgMemo;